export const quotationList = "QUOTATION_LIST";
